var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.001
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 34",
    d: "M0 8a8 8 0 018-8 8 8 0 018 8 8 8 0 01-8 8 8 8 0 01-8-8zm1 0a7.008 7.008 0 007 7 7.007 7.007 0 007-7 7.008 7.008 0 00-7-7 7.008 7.008 0 00-7 7zm4.172 2.828a.5.5 0 010-.708l2.121-2.121-2.121-2.121a.5.5 0 010-.708.5.5 0 01.707 0L8 7.292l2.123-2.122a.5.5 0 01.708 0 .5.5 0 010 .708L8.709 8l2.121 2.12a.5.5 0 010 .708.5.5 0 01-.354.146.5.5 0 01-.353-.146L8.002 8.707l-2.121 2.121a.5.5 0 01-.354.146.5.5 0 01-.355-.146z",
    fill: "#a4262c"
  })));
}
export default SvgNotificationError;